function normalize(value) {
  return String(value || '').trim();
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function isNonAccountIdentifier(value) {
  return ['cash', 'margin', 'individual', 'joint', 'ira', 'traditional_ira', 'roth_ira']
    .includes(normalize(value).toLowerCase());
}

export function maskBrokerAccountIdentifier(value) {
  const text = normalize(value);
  if (!text) return '';
  if (isNonAccountIdentifier(text)) return '';
  if (/[•*]{2,}|\.{3,}/.test(text)) return text;
  if (text.length <= 4) return `••${text}`;
  if (/^\d+$/.test(text)) return `••••${text.slice(-4)}`;
  if (/^[A-Za-z0-9_-]{6,}$/.test(text)) return `${text.slice(0, 2)}••••${text.slice(-4)}`;
  return text;
}

function removeKnownAccountIdentifier(title, connection = {}) {
  let next = title;
  [connection.externalAccountId, connection.externalAccountLabel]
    .map(normalize)
    .filter(Boolean)
    .forEach((identifier) => {
      next = next.replace(new RegExp(`\\s*[-–—]?\\s*${escapeRegExp(identifier)}\\s*[-–—]?\\s*`, 'g'), ' ');
    });
  return next.replace(/\s+/g, ' ').trim();
}

export function getBrokerAccountLabel(connection = {}) {
  const label = maskBrokerAccountIdentifier(connection.externalAccountLabel);
  if (label) return label;
  const accountId = maskBrokerAccountIdentifier(connection.externalAccountId);
  if (accountId) return accountId;
  return '';
}

export function getBrokerConnectionTitle(connection = {}) {
  const title = normalize(connection.displayName);
  if (!title) return '';
  return removeKnownAccountIdentifier(title, connection);
}
